import * as commonConsts from '../../../../pages/common/CommonConsts';

const getValidators = (props) => [
  {
    fieldName: 'hasChangeOfNameCertificateDocument',
    fieldValue: props.documents,
    isValid: (v) => {
      if (!!!props.hasAuthorityNameChange) {
        return true;
      }

      const documents = v.filter((x) => x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateNameChange);

      return documents.length > 0;
    }
  }
];

const errorsDefaultValue = {
  hasChangeOfNameCertificateDocument: false
};

export { getValidators, errorsDefaultValue };
